export const GoogleMapApiConfig = 'AIzaSyC0QDHwARlZBuEYazIXajFSZJ46YdsJTC0';